import script from "./stmn-smpl-prsnt-cnfm.vue?vue&type=script&setup=true&lang=js"
export * from "./stmn-smpl-prsnt-cnfm.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__